import React, { Component } from 'react';
import PopUp from '../../../../commonModules/interface/PopUp';
import { TableLayout } from '../containers/Layout';
import { TableCell, TableBody, TableRow } from '@material-ui/core';

class ConfirmReapproExt extends Component {
    state = {  }
    render() {
        const { reappro } = this.props;
        const fieldList = [
            {name: "shop", label:"Shop", display:reappro.shopDisplay.label},
            // {name: "shop_dest", label:"Shop Destinataire", display:reappro.shop_destDisplay.label},
            {name: "nature", label:"Nature", display:reappro.natureDisplay.label},
            {name: "transport", label:"Coût Transport", display:reappro.transport},
            {name:"taxes", label:"Autres Taxes", display:reappro.taxes},    
            {name:"price_margin", label:"Marge", display:`${reappro.price_margin }%`},            
            {name:"products"},   
            {name:"comments", label:"Commentaires",display:reappro.comments},
            {name:"discount", label:"Réduction Totale", display:reappro.discount},
        ]
        
        return (
            <PopUp 
                title="Confirmation" 
                close={this.props.handleClose}
                submitAction={ this.props.handleSubmit }
                submitTitle="Valider"    
                disabledSubmit={this.props.fetching}
            >
                <TableLayout>
                    <TableBody>
                        
                        {fieldList.map( field => {
                            if(reappro[field.name]){
                                if (field.name === "products"){
                                    return reappro.products.map( prod => (
                                        <TableRow>
                                            <TableCell>{prod.display.label}</TableCell>
                                            <TableCell>{prod.quantity}</TableCell>
                                            
                                            <TableCell></TableCell>
                                        </TableRow>
                                    ))
                                } else {
                                    return (
                                        <TableRow>
                                            <TableCell>{field.label}</TableCell>
                                            <TableCell colSpan={3}>{field.display}</TableCell>
                                        </TableRow>
                                    )
                                }
                            } 
                        })

                        }                            
                    </TableBody>
                </TableLayout>
            </PopUp>
        );
    }
}

export default ConfirmReapproExt;